import type { UndoLineItemPriceOverrideResponse } from '@vy/api-definition';
import { UndoLineItemPriceOverrideResponseSchema } from '@vy/api-definition';
import type { UseMutationOptions } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';
import { getPrivateApi } from '../../../services/api';
import { queryKeys } from '../../../services/query-key/query-keys';
import { invalidateInvoicesQueries } from '../../../utils/query-invalidation';

export type UndoLineItemPriceOverrideRequest = {
  lineItemId: string;
};

export function useUndoLineItemPriceOverride(
  options?: UseMutationOptions<UndoLineItemPriceOverrideResponse, unknown, UndoLineItemPriceOverrideRequest>,
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ lineItemId }) => {
      const lineItemsApi = getPrivateApi();
      const undoLineItemPriceOverrideResponse = await lineItemsApi.undoLineItemPriceOverride({
        lineItemId,
      });

      return UndoLineItemPriceOverrideResponseSchema.parse(undoLineItemPriceOverrideResponse);
    },
    ...options,
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries(queryKeys.dynamicInvoice()),
        invalidateInvoicesQueries(queryClient),
      ]);
    },
  });
}
